import QueryContainer from "./QueryContainer";
import QueryStore from "./QueryStore";
export default QueryStore(QueryContainer);